<template>
  <div class="data-editor">
    <Card>
      <template #title>
        <div class="flex align-items-center">
          <i class="pi pi-table mr-2"></i>
          Управление очками
        </div>
      </template>

      <template #content>
        <!-- Фильтры -->
        <div class="filters-section mb-4">
          <div class="grid">
            <!-- Фильтры очков -->
            <template v-if="catalogView === 'glasses'">
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Бренд</label>
              <Dropdown
                v-model="filters.brand"
                :options="brandOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все бренды"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Категория (Бренд)</label>
              <Dropdown
                v-model="filters.category"
                :options="categoryOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все категории"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Цвет</label>
              <Dropdown
                v-model="filters.color"
                :options="colorOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все цвета"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Статус</label>
              <Dropdown
                v-model="filters.status"
                :options="statusOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все статусы"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Состояние</label>
              <Dropdown
                v-model="filters.condition"
                :options="conditionOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все состояния"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">На складе</label>
              <Dropdown
                v-model="filters.in_stock"
                :options="inStockOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Статус на сайте</label>
              <Dropdown
                v-model="filters.site_status"
                :options="siteStatusOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все статусы"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-6 md:col-2">
              <label class="block text-900 font-medium mb-2">Новинка</label>
              <Dropdown
                v-model="filters.is_new"
                :options="flagOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-6 md:col-2">
              <label class="block text-900 font-medium mb-2">Бестселлер</label>
              <Dropdown
                v-model="filters.is_bestseller"
                :options="flagOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-6 md:col-2">
              <label class="block text-900 font-medium mb-2">Rx</label>
              <Dropdown
                v-model="filters.is_rx"
                :options="flagOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-6 md:col-2">
              <label class="block text-900 font-medium mb-2">Polarized</label>
              <Dropdown
                v-model="filters.is_polarized"
                :options="flagOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-6 md:col-2">
              <label class="block text-900 font-medium mb-2">Photochrome</label>
              <Dropdown
                v-model="filters.is_photochromic"
                :options="flagOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            </template>

            <!-- Фильтры линз -->
            <template v-if="catalogView === 'lenses'">
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Бренд</label>
              <Dropdown
                v-model="filters.brand"
                :options="brandOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все бренды"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Тип линзы</label>
              <Dropdown
                v-model="filters.lens_type"
                :options="lensTypeOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все типы"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            <div class="col-12 md:col-3">
              <label class="block text-900 font-medium mb-2">Статус</label>
              <Dropdown
                v-model="filters.status"
                :options="statusOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Все статусы"
                :showClear="true"
                class="w-full"
                @change="applyFilters"
              />
            </div>
            </template>

            <div class="col-12 md:col-6">
              <label class="block text-900 font-medium mb-2">Поиск</label>
              <InputText
                v-model="filters.search"
                placeholder="Поиск по артикулу..."
                class="w-full"
                @input="debouncedSearch"
              />
            </div>
          </div>
        </div>

        <!-- Переключатель каталога «Очки / Линзы» (над таблицей) -->
        <div class="view-switcher mb-3">
          <SelectButton
            v-model="catalogView"
            :options="catalogViewOptions"
            optionLabel="label"
            optionValue="value"
            :allowEmpty="false"
            @change="onCatalogViewChange"
          />
        </div>

        <!-- Таблица товаров -->
        <div class="table-scroll-wrapper">
          <DataTable
            :value="products"
            :paginator="true"
            :rows="50"
            :loading="loading"
            :totalRecords="totalRecords"
            :lazy="true"
            @page="onPage"
            @sort="onSort"
            selectionMode="single"
            :metaKeySelection="false"
            dataKey="id"
            class="p-datatable-sm wide-products-table"
            editMode="cell"
            @cell-edit-complete="onCellEditComplete"
            @row-select="onRowSelect"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[25, 50, 100]"
            currentPageReportTemplate="Показано {first} - {last} из {totalRecords} товаров"
          >
          <template #empty>
            <div class="text-center py-4">
              <i class="pi pi-info-circle text-4xl text-300 mb-3"></i>
              <p class="text-500">Нет данных для отображения</p>
            </div>
          </template>

          <Column selectionMode="single" headerStyle="width: 3rem"></Column>

                  <Column field="id" header="ID" :sortable="true" style="width: 80px">
                    <template #body="slotProps">
                      <span class="font-monospace">{{ slotProps.data.id }}</span>
                    </template>
                  </Column>

                  <!-- Колонки очков -->
                  <template v-if="catalogView === 'glasses'">
                  <Column field="status" header="Статус" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="condition" header="Состояние" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="in_stock" header="На складе" :sortable="true" style="min-width: 110px">
                    <template #body="{ data }">
                      <span :class="data.in_stock ? 'text-green-500' : 'text-400'">
                        {{ data.in_stock ? '✓' : '—' }}
                      </span>
                    </template>
                  </Column>

                  <Column field="site_status" header="Статус на сайте" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="is_new" header="Новинка" :sortable="true" style="min-width: 100px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="is_bestseller" header="Бестселлер" :sortable="true" style="min-width: 110px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="is_rx" header="Rx" :sortable="true" style="min-width: 80px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="is_polarized" header="Polarized" :sortable="true" style="min-width: 110px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="is_photochromic" header="Photochrome" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="model" header="Модель" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="model_name" header="Model Name" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="brand_cp" header="Бренд (CP)" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="brand" header="Бренд" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="producer" header="Производитель" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="country" header="Страна" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="part_number" header="Артикул (Part Number)" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="part_name" header="Название" :sortable="true" style="min-width: 200px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="category" header="Категория" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="type" header="Тип" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="size" header="Размер" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="color" header="Цвет" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="color_code" header="Код цвета" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="gender" header="Пол" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="age" header="Возраст" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="shape" header="Форма" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="material" header="Материал" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_base" header="Lens Base" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_color" header="Lens Color" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="flex" header="FLEX" :sortable="true" style="min-width: 90px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="nose_pads" header="Nose Pads" :sortable="true" style="min-width: 120px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="rim" header="RIM" :sortable="true" style="min-width: 90px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="year" header="Год" :sortable="true" style="width: 100px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" :min="1900" :max="2030" />
                    </template>
                  </Column>

                  <Column field="bridge" header="Переносица" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="temple_length" header="Длина заушника" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="lens_height" header="Высота линзы" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="hs_code" header="ТН ВЭД" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="rrp" header="РРЦ" :sortable="true" style="min-width: 120px">
                    <template #body="slotProps">
                      <span>{{ slotProps.data.rrp != null ? Number(slotProps.data.rrp).toFixed(2) : '—' }}</span>
                    </template>
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                    </template>
                  </Column>

                  <!-- ── Расширенные поля (цена/релиз/линза/оправа/доп. размеры) ── -->
                  <Column field="wholesale_price" header="Оптовая цена" :sortable="true" style="min-width: 130px">
                    <template #body="slotProps">
                      <span>{{ slotProps.data.wholesale_price != null ? Number(slotProps.data.wholesale_price).toFixed(2) : '—' }}</span>
                    </template>
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
                    </template>
                  </Column>

                  <Column field="currency" header="Валюта" :sortable="true" style="min-width: 90px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="color_name" header="Название цвета" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="frontal_color" header="Цвет фронта" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="temple_color" header="Цвет заушника" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="base_lens_color" header="Базовый цвет линзы" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_type" header="Тип линзы" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_material" header="Материал линзы" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_treatment" header="Обработка линзы" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="transmission_percentage" header="Светопропускание, %" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" %" />
                    </template>
                  </Column>

                  <Column field="filter_protection" header="Категория фильтра" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="temple_material" header="Материал заушника" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="fitting" header="Посадка" :sortable="true" style="min-width: 110px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="bridge_design" header="Дизайн переносицы" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="bridge_fit" header="Посадка переносицы" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="rim_type" header="Тип ободка" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="finish" header="Покрытие/отделка" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="lens_width" header="Ширина линзы" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="diagonal" header="Диагональ" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="hinge_to_hinge" header="Между шарнирами" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="effective_diameter" header="Эффективный диаметр" :sortable="true" style="min-width: 170px">
                    <template #editor="{ data, field }">
                      <InputNumber v-model="data[field]" suffix=" мм" />
                    </template>
                  </Column>

                  <Column field="age_group" header="Возрастная группа" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="face_shape" header="Форма лица" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="marketing_theme" header="Маркетинговая тема" :sortable="true" style="min-width: 160px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="release_season" header="Сезон релиза" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="release_code" header="Код релиза" :sortable="true" style="min-width: 130px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" />
                    </template>
                  </Column>

                  <Column field="availability_date" header="Дата доступности" :sortable="true" style="min-width: 150px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" placeholder="ГГГГ-ММ-ДД" />
                    </template>
                  </Column>

                  <Column field="release_date" header="Дата релиза" :sortable="true" style="min-width: 140px">
                    <template #editor="{ data, field }">
                      <InputText v-model="data[field]" class="w-full" placeholder="ГГГГ-ММ-ДД" />
                    </template>
                  </Column>

                  <Column field="description" header="Описание" :sortable="false" style="min-width: 220px">
                    <template #body="slotProps">
                      <span class="description-cell" :title="slotProps.data.description || '—'">
                        {{ slotProps.data.description || '—' }}
                      </span>
                    </template>
                    <template #editor="{ data, field }">
                      <Textarea v-model="data[field]" autoResize rows="3" class="w-full" />
                    </template>
                  </Column>

                  <!-- Динамические кастомные колонки -->
                  <Column
                    v-for="col in customColumns"
                    :key="col.field_key"
                    :field="'custom_fields.' + col.field_key"
                    :header="col.display_name"
                    :sortable="col.is_sortable"
                    style="min-width: 140px"
                  >
                    <template #body="slotProps">
                      <span>{{ getCustomFieldValue(slotProps.data, col.field_key) || '—' }}</span>
                    </template>
                    <template #editor="{ data }">
                      <InputText
                        v-if="col.data_type === 'string'"
                        :modelValue="getCustomFieldValue(data, col.field_key)"
                        @update:modelValue="val => { if (!data.custom_fields) data.custom_fields = {}; data.custom_fields[col.field_key] = val }"
                        class="w-full"
                      />
                      <InputNumber
                        v-else-if="col.data_type === 'number'"
                        :modelValue="getCustomFieldValue(data, col.field_key)"
                        @update:modelValue="val => { if (!data.custom_fields) data.custom_fields = {}; data.custom_fields[col.field_key] = val }"
                      />
                      <Checkbox
                        v-else-if="col.data_type === 'boolean'"
                        :modelValue="getCustomFieldValue(data, col.field_key)"
                        @update:modelValue="val => { if (!data.custom_fields) data.custom_fields = {}; data.custom_fields[col.field_key] = val }"
                        :binary="true"
                      />
                    </template>
                  </Column>

                  </template>

                  <!-- Колонки линз (короткий набор) -->
                  <template v-if="catalogView === 'lenses'">
                  <Column
                    v-for="col in lensesColumns"
                    :key="col.field"
                    :field="col.field"
                    :header="col.header"
                    :sortable="col.sortable"
                    style="min-width: 130px"
                  >
                    <template #editor="{ data, field }">
                      <InputNumber v-if="col.type === 'number'" v-model="data[field]" class="w-full" />
                      <InputText v-else v-model="data[field]" class="w-full" />
                    </template>
                  </Column>
                  </template>

                  <Column field="images" header="Изображения" style="min-width: 200px">
                    <template #body="slotProps">
                      <div class="images-cell">
                        <span v-if="!hasImages(slotProps.data)" class="text-500">Нет</span>
                        <template v-else>
                          <span class="text-success font-medium">Есть: {{ getImageCount(slotProps.data) }}</span>
                        </template>
                        <Button
                          label="Просмотр"
                          icon="pi pi-images"
                          class="p-button-text p-button-sm"
                          :disabled="!hasImages(slotProps.data)"
                          @click="openImagesModal(slotProps.data)"
                        />
                      </div>
                    </template>
                  </Column>

                  <Column header="Действия" style="width: 140px">
                    <template #body="slotProps">
                      <div class="flex gap-1">
                        <Button
                          icon="pi pi-pencil"
                          class="p-button-rounded p-button-text p-button-info"
                          @click="editProduct(slotProps.data)"
                          v-tooltip.top="'Редактировать'"
                        />
                        <Button
                          icon="pi pi-trash"
                          class="p-button-rounded p-button-text p-button-danger"
                          @click="confirmDelete(slotProps.data)"
                          v-tooltip.top="'Удалить'"
                        />
                      </div>
                    </template>
                  </Column>
                </DataTable>
        </div>

        <!-- Диалог редактирования товара -->
        <Dialog
          v-model:visible="editDialogVisible"
          modal
          header="Редактирование товара"
          :style="{ width: '50rem' }"
          :closable="true"
        >
          <div v-if="selectedProduct" class="p-fluid">
            <div class="grid">
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Артикул (Part Number)</label>
                <InputText v-model="selectedProduct.part_number" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Название</label>
                <InputText v-model="selectedProduct.part_name" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Бренд</label>
                <InputText v-model="selectedProduct.brand" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Категория</label>
                <InputText v-model="selectedProduct.category" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Цвет</label>
                <InputText v-model="selectedProduct.color" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Код цвета</label>
                <InputText v-model="selectedProduct.color_code" placeholder="Например: 2268, BRU0A7, 03-115" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Размер</label>
                <InputText v-model="selectedProduct.size" />
              </div>
              <div class="col-12 md:col-6">
                <label class="block text-900 font-medium mb-2">Год</label>
                <InputNumber v-model="selectedProduct.year" :min="1900" :max="2030" />
              </div>
              <div class="col-12">
                <label class="block text-900 font-medium mb-2">Изображения (URL через запятую)</label>
                <Textarea v-model="selectedProduct.images" :autoResize="true" rows="3" />
              </div>
            </div>
          </div>

          <template #footer>
            <Button
              label="Отмена"
              icon="pi pi-times"
              class="p-button-text"
              @click="editDialogVisible = false"
            />
            <Button
              label="Сохранить"
              icon="pi pi-check"
              class="p-button-primary"
              :loading="saving"
              @click="saveProduct"
            />
          </template>
        </Dialog>

        <!-- Диалог подтверждения удаления -->
        <Dialog
          v-model:visible="deleteDialogVisible"
          modal
          header="Подтверждение удаления"
          :style="{ width: '30rem' }"
        >
          <p>Вы действительно хотите удалить товар "{{ selectedProduct?.part_name }}"?</p>

          <template #footer>
            <Button
              label="Отмена"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDialogVisible = false"
            />
            <Button
              label="Удалить"
              icon="pi pi-trash"
              class="p-button-danger"
              :loading="deleting"
              @click="deleteProduct"
            />
          </template>
        </Dialog>

        <!-- Диалог просмотра изображений -->
        <Dialog
          v-model:visible="imageDialogVisible"
          modal
          :header="imageModalTitle || 'Изображения товара'"
          :style="{ width: '42rem' }"
          :closable="true"
        >
          <div class="image-modal-grid" v-if="selectedImages.length">
            <div
              v-for="(image, index) in selectedImages"
              :key="`${image}-${index}`"
              class="image-modal-item"
            >
              <img :src="image" alt="Изображение товара" />
            </div>
          </div>
          <div v-else class="text-500 text-center py-4">Изображения недоступны</div>
        </Dialog>

        <!-- Диалог экспорта -->
        <ExportDialog v-model:visible="showExportDialog" />

        <!-- Диалог синхронизации с Google Sheets -->
        <Dialog
          v-model:visible="showSheetsSyncDialog"
          header="Синхронизация с Google Sheets"
          :modal="true"
          :style="{ width: '700px' }"
        >
          <TabView v-model:activeIndex="sheetsSyncActiveTab">
            <!-- Вкладка 1: Выгрузка товаров (существующая) -->
            <TabPanel header="Выгрузка товаров">
              <div class="p-fluid">
                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-table mr-2"></i>
                    Таблица Google Sheets
                  </label>
                  <InputText
                    value="Выгрузка товаров ProTrade - CDEK Shopping"
                    readonly
                    class="p-disabled"
                  />
                </div>

                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-link mr-2"></i>
                    Прайс-лист
                  </label>
                  <InputText
                    value="http://user2982-admin.ps-ex.ru/system/unload_prices/30/stockcilenti.csv"
                    readonly
                    class="p-disabled"
                    style="font-size: 0.85rem;"
                  />
                </div>

                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-clock mr-2"></i>
                    Периодичность
                  </label>
                  <InputText
                    value="Каждые 3 часа (автоматически)"
                    readonly
                    class="p-disabled"
                  />
                </div>

                <!-- История синхронизаций -->
                <div v-if="lastSync" class="p-message p-message-info mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-info-circle"></span>
                    <div class="p-message-text">
                      <strong>Последняя синхронизация:</strong><br/>
                      {{ formatDate(lastSync.report_date) }}<br/>
                      <span class="text-sm">
                        Обработано: {{ lastSync.total_products }},
                        Успешно: {{ lastSync.success_count }},
                        Пропущено: {{ lastSync.missing_data_count }}
                      </span>
                      <div v-if="lastSync.missing_data_count > 0" class="mt-2">
                        <Button
                          label="Скачать отчет"
                          icon="pi pi-download"
                          class="p-button-sm p-button-outlined"
                          :loading="downloadingReport"
                          @click="downloadSyncReport(lastSync.id)"
                        />
                        <small class="ml-2 text-500">Содержит список пропущенных артикулов</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else class="p-message p-message-warn mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-exclamation-triangle"></span>
                    <div class="p-message-text">
                      Синхронизация еще не выполнялась
                    </div>
                  </div>
                </div>

                <!-- Информационное сообщение -->
                <div class="p-message p-message-secondary">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-info-circle"></span>
                    <div class="p-message-text">
                      <strong>Что будет синхронизировано:</strong>
                      <ul class="mt-2 ml-3 text-sm">
                        <li>20 полей из базы данных</li>
                        <li>Количество и цена из прайс-листа</li>
                        <li>Обновление существующих товаров</li>
                        <li>Добавление новых товаров</li>
                        <li>Удаление отсутствующих в прайсе</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Прогресс синхронизации -->
                <div v-if="sheetsSyncProgress" class="p-message p-message-info mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-spin pi-spinner"></span>
                    <div class="p-message-text" style="width: 100%">
                      <div class="flex justify-content-between align-items-center mb-2">
                        <strong>{{ sheetsSyncProgress.stage_label }}</strong>
                        <span class="text-sm">{{ sheetsSyncProgress.percent }}%</span>
                      </div>
                      <ProgressBar :value="sheetsSyncProgress.percent" :showValue="false" style="height: 6px" />
                      <div v-if="sheetsSyncProgress.message" class="text-sm mt-1 text-500">
                        {{ sheetsSyncProgress.message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex justify-content-end mt-4">
                  <Button
                    label="Запустить синхронизацию"
                    icon="pi pi-refresh"
                    class="p-button-success"
                    :loading="syncingSheets"
                    :disabled="syncingSheets"
                    @click="startSheetsSync"
                  />
                </div>
              </div>
            </TabPanel>

            <!-- Вкладка 2: Chanel Perfumes (обновление цен) -->
            <TabPanel header="Chanel Perfumes">
              <div class="p-fluid">
                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-table mr-2"></i>
                    Таблица Google Sheets
                  </label>
                  <InputText
                    value="chanelperfumes"
                    readonly
                    class="p-disabled"
                  />
                </div>

                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-link mr-2"></i>
                    Прайс-лист CSV
                  </label>
                  <InputText
                    value="http://user2982-admin.ps-ex.ru/system/unload_prices/37/chanelperfumes.csv"
                    readonly
                    class="p-disabled"
                    style="font-size: 0.85rem;"
                  />
                </div>

                <div class="field mb-4">
                  <label class="block text-900 font-medium mb-2">
                    <i class="pi pi-clock mr-2"></i>
                    Периодичность
                  </label>
                  <InputText
                    value="Каждые 3 часа (автоматически)"
                    readonly
                    class="p-disabled"
                  />
                </div>

                <!-- История синхронизаций -->
                <div v-if="chanelLastSync" class="p-message p-message-info mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-info-circle"></span>
                    <div class="p-message-text">
                      <strong>Последняя синхронизация:</strong><br/>
                      {{ formatDate(chanelLastSync.report_date) }}<br/>
                      <span class="text-sm">
                        Всего в CSV: {{ chanelLastSync.details_json?.total_csv || chanelLastSync.total_products }},
                        В таблице: {{ chanelLastSync.details_json?.total_sheet || '-' }}<br/>
                        Обновлено цен: {{ chanelLastSync.details_json?.updated || chanelLastSync.success_count }},
                        Уже актуальны: {{ chanelLastSync.details_json?.already_current || '-' }},
                        Не найдены: {{ chanelLastSync.missing_data_count }}
                      </span>
                    </div>
                  </div>
                </div>

                <div v-else class="p-message p-message-warn mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-exclamation-triangle"></span>
                    <div class="p-message-text">
                      Синхронизация еще не выполнялась
                    </div>
                  </div>
                </div>

                <!-- Информационное сообщение -->
                <div class="p-message p-message-secondary">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-info-circle"></span>
                    <div class="p-message-text">
                      <strong>Что будет синхронизировано:</strong>
                      <ul class="mt-2 ml-3 text-sm">
                        <li>Поиск товаров по EAN (штрихкод)</li>
                        <li>Обновление цены из CSV в таблицу</li>
                        <li>Бренды: CHANEL, YSL, HERMES, GUCCI</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Прогресс синхронизации -->
                <div v-if="chanelSyncProgress" class="p-message p-message-info mb-3">
                  <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-spin pi-spinner"></span>
                    <div class="p-message-text" style="width: 100%">
                      <div class="flex justify-content-between align-items-center mb-2">
                        <strong>{{ chanelSyncProgress.stage_label }}</strong>
                        <span class="text-sm">{{ chanelSyncProgress.percent }}%</span>
                      </div>
                      <ProgressBar :value="chanelSyncProgress.percent" :showValue="false" style="height: 6px" />
                      <div v-if="chanelSyncProgress.message" class="text-sm mt-1 text-500">
                        {{ chanelSyncProgress.message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex justify-content-end mt-4">
                  <Button
                    label="Запустить синхронизацию цен"
                    icon="pi pi-refresh"
                    class="p-button-success"
                    :loading="syncingChanel"
                    :disabled="syncingChanel"
                    @click="startChanelSync"
                  />
                </div>
              </div>
            </TabPanel>
          </TabView>

          <template #footer>
            <Button
              label="Закрыть"
              icon="pi pi-times"
              class="p-button-text"
              @click="showSheetsSyncDialog = false"
            />
          </template>
        </Dialog>

        <!-- Диалог конвертера UPC - ТНВЭД -->
        <Dialog
          v-model:visible="showUpcConverterDialog"
          modal
          header="Конвертер UPC - ТНВЭД"
          :style="{ width: '50rem' }"
          :closable="true"
        >
          <div class="p-fluid">
            <div class="mb-3">
              <label class="block text-900 font-medium mb-2">Введите список UPC кодов (каждый с новой строки)</label>
              <Textarea 
                v-model="upcCodesInput" 
                :autoResize="true" 
                rows="15" 
                placeholder="8056262010716&#10;8056262247471&#10;8056262247471&#10;..."
                class="w-full"
              />
              <small class="text-500">Вставьте коды UPC (part_number), по одному на строку</small>
            </div>
          </div>

          <template #footer>
            <Button
              label="Отмена"
              icon="pi pi-times"
              class="p-button-text"
              @click="showUpcConverterDialog = false"
            />
            <Button
              label="Преобразовать"
              icon="pi pi-file-excel"
              class="p-button-success"
              :loading="convertingUpc"
              :disabled="!upcCodesInput.trim()"
              @click="convertUpcToTnved"
            />
          </template>
        </Dialog>

        <!-- Диалог синхронизации -->
        <Dialog
          v-model:visible="showSyncDialog"
          modal
          header="Синхронизация данных"
          :style="{ width: '40rem' }"
          :closable="true"
        >
          <div class="p-fluid">
            <div class="mb-3">
              <p class="text-600 mb-3">Выберите операции для выполнения:</p>
              
              <div class="field-checkbox mb-3">
                <Checkbox v-model="syncOptions.producers" inputId="sync-producers" :binary="true" />
                <label for="sync-producers" class="ml-2">
                  <i class="pi pi-briefcase mr-2"></i>
                  <strong>Обновить производителей</strong>
                  <br />
                  <small class="text-500">Заполнить поле "Производитель" на основе маппинга брендов</small>
                </label>
              </div>

              <div class="field-checkbox mb-3">
                <Checkbox v-model="syncOptions.priceFeed" inputId="sync-price" :binary="true" />
                <label for="sync-price" class="ml-2">
                  <i class="pi pi-list mr-2"></i>
                  <strong>Синхронизировать прайс-лист</strong>
                  <br />
                  <small class="text-500">Обновить статусы товаров (ACTIVE/ARCHIVE) по прайс-листу</small>
                </label>
              </div>

              <div class="field-checkbox mb-3">
                <Checkbox v-model="syncOptions.conditions" inputId="sync-conditions" :binary="true" />
                <label for="sync-conditions" class="ml-2">
                  <i class="pi pi-flag mr-2"></i>
                  <strong>Обновить состояние</strong>
                  <br />
                  <small class="text-500">Пересчитать колонку «Состояние» из статусов сайта + demo-фида (по крону раз в 2 часа)</small>
                </label>
              </div>

              <div class="field-checkbox mb-3">
                <Checkbox v-model="syncOptions.images" inputId="sync-images" :binary="true" />
                <label for="sync-images" class="ml-2">
                  <i class="pi pi-image mr-2"></i>
                  <strong>Синхронизировать изображения</strong>
                  <br />
                  <small class="text-500">Найти и привязать изображения из S3 к товарам</small>
                </label>
              </div>

              <div class="field-checkbox mb-3">
                <Checkbox v-model="syncOptions.descriptions" inputId="sync-descriptions" :binary="true" />
                <label for="sync-descriptions" class="ml-2">
                  <i class="pi pi-file-edit mr-2"></i>
                  <strong>Генерировать описания</strong>
                  <br />
                  <small class="text-500">Создать HTML-описания с размерами для товаров</small>
                </label>
              </div>

              <div v-if="syncOptions.descriptions" class="ml-5 mb-3">
                <div class="field mb-3">
                  <div class="field-checkbox">
                    <Checkbox v-model="syncOptions.onlyWithoutDescriptions" inputId="only-without-desc" :binary="true" />
                    <label for="only-without-desc" class="ml-2">
                      <strong>Только товары без описаний</strong>
                      <br />
                      <small class="text-500">Пропустить товары с уже заполненным полем description</small>
                    </label>
                  </div>
                </div>

                <div class="field mb-3">
                  <label for="brand-multiselect" class="block text-900 font-medium mb-2">
                    Выбрать бренды
                  </label>
                  <MultiSelect 
                    v-model="syncOptions.selectedBrands" 
                    :options="brandOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Все бренды"
                    :filter="true"
                    :showClear="true"
                    display="chip"
                    class="w-full"
                  >
                    <template #value="slotProps">
                      <div v-if="!slotProps.value || slotProps.value.length === 0" class="text-500">
                        Все бренды
                      </div>
                      <div v-else class="flex align-items-center gap-2 flex-wrap">
                        <div v-for="brand in slotProps.value" :key="brand" class="p-tag">
                          {{ brandOptions.find(b => b.value === brand)?.label || brand }}
                        </div>
                      </div>
                    </template>
                  </MultiSelect>
                  <small class="text-500">Оставьте пустым для обработки всех брендов</small>
                </div>
              </div>

              <div v-if="!hasSelectedOptions" class="p-message p-message-warn mt-3">
                <div class="p-message-wrapper">
                  <span class="p-message-icon pi pi-exclamation-triangle"></span>
                  <div class="p-message-text">
                    Выберите хотя бы одну операцию для синхронизации
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template #footer>
            <Button
              label="Отмена"
              icon="pi pi-times"
              class="p-button-text"
              @click="showSyncDialog = false"
            />
            <Button
              label="Начать синхронизацию"
              icon="pi pi-refresh"
              class="p-button-success"
              :disabled="!hasSelectedOptions"
              @click="startSync"
            />
          </template>
        </Dialog>

        <!-- Диалог массового редактирования -->
        <BulkEditDialog
          v-model:visible="showBulkEditDialog"
          :brandOptions="brandOptions"
          @changes-applied="loadProducts"
        />

        <!-- Диалог таможенного документа -->
        <ShipmentExportDialog v-model:visible="showShipmentExportDialog" />
      </template>
    </Card>
  </div>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted, computed, watch } from 'vue'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import SelectButton from 'primevue/selectbutton'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import ProgressBar from 'primevue/progressbar'
import ExportDialog from './ExportDialog.vue'
import BulkEditDialog from './BulkEditDialog.vue'
import ShipmentExportDialog from './ShipmentExportDialog.vue'
import { useToast } from 'primevue/usetoast'
import apiService from '../services/apiService'
import customColumnsService from '../services/customColumnsService'

export default {
  name: 'DataEditor',
  emits: ['show-enrichment'],
  components: {
    Card,
    DataTable,
    Column,
    Button,
    InputText,
    InputNumber,
    Dropdown,
    MultiSelect,
    Dialog,
    Textarea,
    Checkbox,
    SelectButton,
    ExportDialog,
    BulkEditDialog,
    ShipmentExportDialog,
    TabView,
    TabPanel
  },
  setup() {
    const toast = useToast()
    const products = ref([])
    const loading = ref(false)
    const refreshing = ref(false)
    const totalRecords = ref(0)
    const selectedProduct = ref(null)
    const editDialogVisible = ref(false)
    const deleteDialogVisible = ref(false)
    const imageDialogVisible = ref(false)
    const showExportDialog = ref(false)
    const showBulkEditDialog = ref(false)
    const selectedImages = ref([])
    const imageModalTitle = ref('')
    const saving = ref(false)
    const deleting = ref(false)

    // Sync Dialog
    const showSyncDialog = ref(false)
    const syncOptions = reactive({
      producers: true,
      priceFeed: true,
      conditions: false,
      images: false,
      descriptions: false,
      selectedBrands: [],
      onlyWithoutDescriptions: false
    })

    // UPC Converter
    const showUpcConverterDialog = ref(false)

    // Shipment Export
    const showShipmentExportDialog = ref(false)
    const upcCodesInput = ref('')
    const convertingUpc = ref(false)

    // Google Sheets Sync
    const showSheetsSyncDialog = ref(false)
    const syncingSheets = ref(false)
    const lastSync = ref(null)
    const downloadingReport = ref(false)
    const sheetsSyncActiveTab = ref(0)
    const sheetsSyncProgress = ref(null)
    const sheetsProgressPolling = ref(null)

    // Chanel Perfumes Sync
    const syncingChanel = ref(false)
    const chanelLastSync = ref(null)
    const chanelSyncProgress = ref(null)
    const chanelProgressPolling = ref(null)

    const filters = reactive({
      brand: null,
      category: null,
      color: null,
      status: null,
      condition: null,
      in_stock: null,
      site_status: null,
      is_new: null,
      is_bestseller: null,
      is_rx: null,
      is_polarized: null,
      is_photochromic: null,
      // фильтры линз
      lens_type: null,
      model: null,
      search: '',
      page: 0,
      size: 50,
      sortField: null,
      sortOrder: null
    })

    // ===== Переключатель каталога «Очки / Линзы» =====
    const catalogView = ref(sessionStorage.getItem('ai-catalog-view') || 'glasses')
    const catalogViewOptions = ref([
      { label: 'Очки', value: 'glasses' },
      { label: 'Линзы', value: 'lenses' }
    ])
    const lensTypeOptions = ref([])
    // Короткий набор колонок для линз (см. LENSES_SPEC_SERVER.md §5c)
    const lensesColumns = ref([
      { field: 'brand', header: 'Бренд', sortable: true, type: 'text' },
      { field: 'model', header: 'Модель', sortable: true, type: 'text' },
      { field: 'part_number', header: 'EAN/Штрихкод', sortable: true, type: 'text' },
      { field: 'supplier_code', header: 'Артикул пост.', sortable: true, type: 'text' },
      { field: 'lens_type', header: 'Тип', sortable: true, type: 'text' },
      { field: 'base_curve', header: 'Кривизна (BC)', sortable: true, type: 'number' },
      { field: 'diameter', header: 'Диаметр (DIA)', sortable: true, type: 'number' },
      { field: 'power', header: 'Диоптрии (PWR)', sortable: true, type: 'number' },
      { field: 'cylinder', header: 'Цилиндр (CYL)', sortable: true, type: 'number' },
      { field: 'axis', header: 'Ось (AXIS)', sortable: true, type: 'number' },
      { field: 'add_power', header: 'Аддидация (ADD)', sortable: true, type: 'text' },
      { field: 'pack_size', header: 'Упаковка (шт)', sortable: true, type: 'number' },
      { field: 'list_price', header: 'Цена', sortable: true, type: 'number' },
      { field: 'currency', header: 'Валюта', sortable: true, type: 'text' },
      { field: 'mtyp', header: 'MTyp', sortable: true, type: 'text' },
      { field: 'brand_code', header: 'Код бренда', sortable: true, type: 'text' },
      { field: 'family_group', header: 'Группа сем.', sortable: true, type: 'text' },
      { field: 'prod_fam_code', header: 'Код семейства', sortable: true, type: 'text' },
      { field: 'material_type', header: 'Тип материала', sortable: true, type: 'text' },
      { field: 'plant', header: 'Завод/склад', sortable: true, type: 'text' },
      { field: 'upc11', header: 'UPC11', sortable: true, type: 'text' },
      { field: 'image_file', header: 'Файл картинки', sortable: true, type: 'text' },
      { field: 'param_type_value_id', header: 'Param Type Value ID', sortable: true, type: 'text' },
      { field: 'product_type', header: 'Product Type', sortable: true, type: 'text' },
      { field: 'description', header: 'Описание (упак.)', sortable: false, type: 'text' },
      { field: 'description_sku', header: 'Описание (SKU)', sortable: false, type: 'text' },
      { field: 'status', header: 'Статус', sortable: true, type: 'text' }
    ])
    const onCatalogViewChange = () => {
      sessionStorage.setItem('ai-catalog-view', catalogView.value)
      filters.page = 0
      loadFilterOptions()
      loadProducts()
    }

    const brandOptions = ref([])
    const categoryOptions = ref([])
    const colorOptions = ref([])
    const conditionOptions = ref([])
    const inStockOptions = ref([
      { label: 'На складе', value: true },
      { label: 'Не на складе', value: false },
    ])
    const siteStatusOptions = ref([])
    const statusOptions = ref([
      { label: 'Актив', value: 'ACTIVE' },
      { label: 'Архив', value: 'ARCHIVE' }
    ])
    const flagOptions = ref([
      { label: '1 — Да', value: '1' },
      { label: '0 — Нет', value: '0' }
    ])

    // Кастомные колонки
    const customColumns = ref([])

    const loadFilterOptions = async () => {
      try {
        if (catalogView.value === 'lenses') {
          const response = await apiService.getLensFilterOptions()
          const data = response.data
          brandOptions.value = (data.brands || []).map(item => ({ label: item, value: item }))
          lensTypeOptions.value = (data.lens_types || []).map(item => ({ label: item, value: item }))
          return
        }
        const response = await apiService.getFilterOptions()
        const data = response.data

  brandOptions.value = (data.brands || []).map(item => ({ label: item, value: item }))
  categoryOptions.value = (data.categories || []).map(item => ({ label: item, value: item }))
  colorOptions.value = (data.colors || []).map(item => ({ label: item, value: item }))
  conditionOptions.value = (data.conditions || []).map(item => ({ label: item, value: item }))
  siteStatusOptions.value = (data.site_statuses || []).map(item => ({ label: item, value: item }))
  // statusOptions - статические значения, уже заданы при инициализации
      } catch (error) {
        console.error('Error loading filter options:', error)
      }
    }

    // Загрузка кастомных колонок
    const loadCustomColumns = async () => {
      try {
        const response = await customColumnsService.getAll(false) // Только активные
        customColumns.value = response.items || []
      } catch (error) {
        console.error('Error loading custom columns:', error)
      }
    }

    // Получение значения кастомного поля из товара
    const getCustomFieldValue = (product, fieldKey) => {
      return product?.custom_fields?.[fieldKey] || null
    }

    const loadProducts = async () => {
      loading.value = true
      try {
        const isLenses = catalogView.value === 'lenses'
        const params = isLenses
          ? {
              brand: filters.brand,
              model: filters.model,
              lens_type: filters.lens_type,
              status: filters.status,
              search: filters.search,
              limit: filters.size,
              offset: filters.page * filters.size
            }
          : {
              brand: filters.brand,
              category: filters.category,
              color: filters.color,
              status: filters.status,
              condition: filters.condition,
              in_stock: filters.in_stock,
              site_status: filters.site_status,
              is_new: filters.is_new,
              is_bestseller: filters.is_bestseller,
              is_rx: filters.is_rx,
              is_polarized: filters.is_polarized,
              is_photochromic: filters.is_photochromic,
              search: filters.search,
              limit: filters.size,
              offset: filters.page * filters.size
            }

        if (filters.sortField) {
          params.sort_field = filters.sortField
          params.sort_order = filters.sortOrder === 1 ? 'asc' : 'desc'
        }

        const response = isLenses
          ? await apiService.getLenses(params)
          : await apiService.getProducts(params)

        // Обновляем данные с учетом новой структуры ответа
        if (response.data.products) {
          products.value = response.data.products
          totalRecords.value = response.data.total_count
        } else {
          // Поддержка старого формата для совместимости
          products.value = response.data
          totalRecords.value = response.data.length
        }
      } catch (error) {
        console.error('Error loading products:', error)
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось загрузить товары',
          life: 3000
        })
      } finally {
        loading.value = false
      }
    }

    // Computed для проверки выбранных опций
    const hasSelectedOptions = computed(() => {
      return syncOptions.producers || syncOptions.priceFeed || syncOptions.conditions || syncOptions.images || syncOptions.descriptions
    })

    // Новая функция синхронизации с выбором операций
    const startSync = async () => {
      showSyncDialog.value = false
      
      const operations = []
      if (syncOptions.producers) operations.push('производителей')
      if (syncOptions.priceFeed) operations.push('прайс-лист')
      if (syncOptions.conditions) operations.push('состояние')
      if (syncOptions.images) operations.push('изображения')
      if (syncOptions.descriptions) operations.push('описания')
      
      toast.add({
        severity: 'info',
        summary: 'Синхронизация начата',
        detail: `Запущены операции: ${operations.join(', ')}. Процесс выполняется в фоновом режиме.`,
        life: 5000
      })

      try {
        // Параллельный запуск выбранных операций
        const promises = []
        
        if (syncOptions.producers) {
          promises.push(
            apiService.syncProducers()
              .then(response => ({
                type: 'producers',
                success: true,
                data: response.data
              }))
              .catch(error => ({
                type: 'producers',
                success: false,
                error: error.response?.data?.detail || error.message
              }))
          )
        }

        if (syncOptions.priceFeed) {
          promises.push(
            apiService.syncPriceFeed()
              .then(response => ({
                type: 'priceFeed',
                success: true,
                data: response.data
              }))
              .catch(error => ({
                type: 'priceFeed',
                success: false,
                error: error.response?.data?.detail || error.message
              }))
          )
        }

        if (syncOptions.conditions) {
          promises.push(
            apiService.syncConditions()
              .then(response => ({
                type: 'conditions',
                success: true,
                background: true,
                task_id: response.data?.task_id,
                data: response.data
              }))
              .catch(error => ({
                type: 'conditions',
                success: false,
                error: error.response?.data?.detail || error.message
              }))
          )
        }

        if (syncOptions.images) {
          promises.push(
            apiService.syncImages()
              .then(response => {
                // Проверяем, запущена ли фоновая задача
                if (response.data.task_id) {
                  return {
                    type: 'images',
                    success: true,
                    background: true,
                    task_id: response.data.task_id,
                    data: response.data
                  }
                }
                // Старый формат для обратной совместимости
                return {
                  type: 'images',
                  success: true,
                  background: false,
                  data: response.data
                }
              })
              .catch(error => ({
                type: 'images',
                success: false,
                error: error.response?.data?.detail || error.message
              }))
          )
        }

        if (syncOptions.descriptions) {
          const params = {
            brand_cp: syncOptions.selectedBrands.length > 0 ? syncOptions.selectedBrands : null,
            only_without_descriptions: syncOptions.onlyWithoutDescriptions
          }
          
          promises.push(
            apiService.regenerateDescriptions(params)
              .then(response => ({
                type: 'descriptions',
                success: true,
                data: response.data
              }))
              .catch(error => ({
                type: 'descriptions',
                success: false,
                error: error.response?.data?.detail || error.message
              }))
          )
        }

        // Ждем завершения всех операций
        const results = await Promise.all(promises)
        
        // Формируем сообщение с результатами
        const successOps = results.filter(r => r.success)
        const failedOps = results.filter(r => !r.success)
        const backgroundTasks = results.filter(r => r.success && r.background)
        
        if (successOps.length > 0) {
          const details = successOps.map(op => {
            const opName = {
              producers: 'Производители',
              priceFeed: 'Прайс-лист',
              conditions: 'Состояние',
              images: 'Изображения',
              descriptions: 'Описания'
            }[op.type]
            
            // Если задача запущена в фоне
            if (op.background) {
              return `${opName}: запущено в фоновом режиме (ID: ${op.task_id})`
            }
            
            let stat = ''
            if (op.type === 'producers') {
              stat = `обновлено: ${op.data?.stats?.updated || 0}`
            } else if (op.type === 'priceFeed') {
              const s = op.data?.summary || {}
              stat = `обработано: ${s.processed || 0}, активировано: ${s.activated || 0}, архивировано: ${s.archived || 0}`
            } else if (op.type === 'images') {
              const s = op.data?.stats || {}
              stat = `обработано: ${s.processed || 0}, обновлено: ${s.updated || 0}`
            } else if (op.type === 'descriptions') {
              const s = op.data?.stats || {}
              stat = `групп: ${s.groups || 0}, обновлено: ${s.updated || 0}`
            }
            
            return `${opName}: ${stat}`
          }).join('\n')
          
          const severity = backgroundTasks.length > 0 ? 'info' : 'success'
          const summary = backgroundTasks.length > 0 
            ? 'Синхронизация запущена' 
            : 'Синхронизация завершена'
          
          toast.add({
            severity: severity,
            summary: summary,
            detail: details,
            life: 6000
          })
        }
        
        if (failedOps.length > 0) {
          const errorDetails = failedOps.map(op => {
            const opName = {
              producers: 'Производители',
              priceFeed: 'Прайс-лист',
              conditions: 'Состояние',
              images: 'Изображения',
              descriptions: 'Описания'
            }[op.type]
            return `${opName}: ${op.error}`
          }).join('\n')
          
          toast.add({
            severity: 'error',
            summary: 'Ошибки синхронизации',
            detail: errorDetails,
            life: 6000
          })
        }
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Произошла ошибка при синхронизации',
          life: 4000
        })
      } finally {
        // Перезагружаем товары после синхронизации
        await loadProducts()
      }
    }

    const parseImageList = (value) => {
      if (!value) return []
      if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter(Boolean)
      }
      return String(value)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    }

    const getImageList = (product) => {
      if (!product) return []
      return parseImageList(product.images)
    }

    const getImageCount = (product) => getImageList(product).length

    const hasImages = (product) => getImageCount(product) > 0

    const openImagesModal = (product) => {
      const images = getImageList(product)
      if (!images.length) {
        return
      }

      selectedImages.value = images
      imageModalTitle.value = product?.part_number
        ? `Изображения ${product.part_number}`
        : 'Изображения товара'
      imageDialogVisible.value = true
    }

    const updateFilterOptions = (data) => {
      // Удаляем эту функцию, так как теперь используем отдельный API endpoint
    }

    const applyFilters = () => {
      filters.page = 0
      loadProducts()
    }

    const debouncedSearch = (() => {
      let timeout
      return () => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          applyFilters()
        }, 500)
      }
    })()

    const onPage = (event) => {
      filters.page = event.page
      filters.size = event.rows
      loadProducts()
    }

    const onSort = (event) => {
      let sortField = event.sortField
      // Преобразуем формат для кастомных полей: custom_fields.key -> custom:key
      if (sortField && sortField.startsWith('custom_fields.')) {
        sortField = 'custom:' + sortField.replace('custom_fields.', '')
      }
      filters.sortField = sortField
      filters.sortOrder = event.sortOrder
      loadProducts()
    }

    const onRowSelect = (event) => {
      selectedProduct.value = { ...event.data }
    }

    const onCellEditComplete = async (event) => {
      const { data, newValue, field } = event

      // Обработка кастомных полей (формат: custom_fields.field_key)
      if (field && field.startsWith('custom_fields.')) {
        const fieldKey = field.replace('custom_fields.', '')
        const currentValue = data.custom_fields?.[fieldKey]
        if (newValue !== currentValue) {
          try {
            // Мержим новое значение с существующими custom_fields
            const updatedCustomFields = {
              ...(data.custom_fields || {}),
              [fieldKey]: newValue
            }
            await apiService.updateProduct(data.id, { custom_fields: updatedCustomFields })
            toast.add({
              severity: 'success',
              summary: 'Успешно',
              detail: 'Данные обновлены',
              life: 2000
            })
            loadProducts()
          } catch (error) {
            toast.add({
              severity: 'error',
              summary: 'Ошибка',
              detail: 'Не удалось обновить данные',
              life: 3000
            })
          }
        }
        return
      }

      // Обработка обычных полей
      if (newValue !== data[field]) {
        try {
          if (catalogView.value === 'lenses') {
            await apiService.updateLens(data.id, { [field]: newValue })
          } else {
            await apiService.updateProduct(data.id, { [field]: newValue })
          }
          toast.add({
            severity: 'success',
            summary: 'Успешно',
            detail: 'Данные обновлены',
            life: 2000
          })
          loadProducts()
        } catch (error) {
          toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: 'Не удалось обновить данные',
            life: 3000
          })
        }
      }
    }

    const editProduct = (product) => {
      selectedProduct.value = { ...product }
      editDialogVisible.value = true
    }

    const saveProduct = async () => {
      if (!selectedProduct.value) return

      saving.value = true
      try {
        if (catalogView.value === 'lenses') {
          await apiService.updateLens(selectedProduct.value.id, selectedProduct.value)
        } else {
          await apiService.updateProduct(selectedProduct.value.id, selectedProduct.value)
        }
        editDialogVisible.value = false
        loadProducts()
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Товар обновлен',
          life: 2000
        })
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось сохранить изменения',
          life: 3000
        })
      } finally {
        saving.value = false
      }
    }

    const confirmDelete = (product) => {
      selectedProduct.value = product
      deleteDialogVisible.value = true
    }

    const deleteProduct = async () => {
      if (!selectedProduct.value) return

      deleting.value = true
      try {
        if (catalogView.value === 'lenses') {
          await apiService.deleteLens(selectedProduct.value.id)
        } else {
          await apiService.deleteProduct(selectedProduct.value.id)
        }
        deleteDialogVisible.value = false
        loadProducts()
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Товар удален',
          life: 2000
        })
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось удалить товар',
          life: 3000
        })
      } finally {
        deleting.value = false
      }
    }

    const convertUpcToTnved = async () => {
      try {
        convertingUpc.value = true

        // Парсим введенные UPC коды
        const upcCodes = upcCodesInput.value
          .split('\n')
          .map(code => code.trim())
          .filter(code => code.length > 0)

        if (upcCodes.length === 0) {
          toast.add({
            severity: 'warn',
            summary: 'Предупреждение',
            detail: 'Введите хотя бы один UPC код',
            life: 3000
          })
          return
        }

        // Отправляем запрос на backend
        const response = await apiService.convertUpcToTnved({ upc_codes: upcCodes })

        if (!response.data || response.data.length === 0) {
          toast.add({
            severity: 'warn',
            summary: 'Предупреждение',
            detail: 'Не найдено данных для указанных UPC кодов',
            life: 3000
          })
          return
        }

        // Создаем Excel файл на фронтенде
        const XLSX = await import('xlsx')
        
        // Форматируем данные для Excel
        const worksheetData = [
          ['UPC', 'Тип', 'ТНВЭД'], // Заголовки
          ...response.data.map(item => [
            item.upc || '',
            item.type || '',
            item.tnved || ''
          ])
        ]

        // Создаем workbook и worksheet
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(worksheetData)

        // Добавляем worksheet в workbook
        XLSX.utils.book_append_sheet(wb, ws, 'UPC-ТНВЭД')

        // Генерируем и скачиваем файл
        const fileName = `upc_tnved_${new Date().toISOString().split('T')[0]}.xlsx`
        XLSX.writeFile(wb, fileName)

        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: `Файл ${fileName} успешно создан и загружен`,
          life: 3000
        })

        // Закрываем диалог и очищаем поле
        showUpcConverterDialog.value = false
        upcCodesInput.value = ''

      } catch (error) {
        console.error('Error converting UPC to TNVED:', error)
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: error.response?.data?.detail || 'Не удалось выполнить конвертацию',
          life: 5000
        })
      } finally {
        convertingUpc.value = false
      }
    }

    const formatDate = (dateStr) => {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
    
    const loadLastSync = async () => {
      try {
        const response = await apiService.getSheetsSyncStatus()
        lastSync.value = response.data.last_sync
      } catch (error) {
        console.error('Error loading sync status:', error)
      }
    }
    
    const stopSheetsPolling = () => {
      if (sheetsProgressPolling.value) {
        clearInterval(sheetsProgressPolling.value)
        sheetsProgressPolling.value = null
      }
    }

    const pollSheetsProgress = () => {
      stopSheetsPolling()
      sheetsProgressPolling.value = setInterval(async () => {
        try {
          const resp = await apiService.getSheetsSyncProgress('sheets')
          if (resp.data.running) {
            sheetsSyncProgress.value = resp.data
          } else {
            sheetsSyncProgress.value = null
            stopSheetsPolling()
            syncingSheets.value = false
            await loadLastSync()
            if (resp.data.error) {
              toast.add({ severity: 'error', summary: 'Ошибка синхронизации', detail: resp.data.error, life: 5000 })
            } else if (resp.data.stage === 'completed') {
              toast.add({ severity: 'success', summary: 'Синхронизация завершена', life: 3000 })
            }
          }
        } catch (e) {
          console.error('Error polling sheets progress:', e)
        }
      }, 2000)
    }

    const startSheetsSync = async () => {
      if (syncingSheets.value) return
      syncingSheets.value = true

      try {
        const statusResp = await apiService.checkSheetsSyncRunning()
        if (statusResp.data.running) {
          toast.add({
            severity: 'warn',
            summary: 'Синхронизация уже выполняется',
            detail: 'Отображаем текущий прогресс',
            life: 3000
          })
          pollSheetsProgress()
          return
        }

        await apiService.triggerSheetsSync()
        pollSheetsProgress()
      } catch (error) {
        if (error.response?.status === 409) {
          pollSheetsProgress()
        } else {
          toast.add({
            severity: 'error',
            summary: 'Ошибка синхронизации',
            detail: error.response?.data?.detail || error.message,
            life: 5000
          })
          syncingSheets.value = false
        }
      }
    }
    
    const downloadSyncReport = async (reportId) => {
      downloadingReport.value = true
      try {
        const response = await apiService.downloadSheetsSyncReport(reportId)
        
        // Создаем ссылку для скачивания
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        
        // Извлекаем имя файла из заголовка или генерируем
        const contentDisposition = response.headers['content-disposition']
        let filename = 'google_sheets_sync_report.xlsx'
        if (contentDisposition) {
          const match = contentDisposition.match(/filename=(.+)/)
          if (match) {
            filename = match[1]
          }
        }
        
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        
        toast.add({
          severity: 'success',
          summary: 'Отчет скачан',
          detail: 'Файл содержит статистику и список пропущенных артикулов',
          life: 3000
        })
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Ошибка скачивания',
          detail: error.response?.data?.detail || error.message,
          life: 5000
        })
      } finally {
        downloadingReport.value = false
      }
    }

    const loadChanelLastSync = async () => {
      try {
        const response = await apiService.getChanelSyncStatus()
        chanelLastSync.value = response.data.last_sync
      } catch (error) {
        console.error('Error loading Chanel sync status:', error)
      }
    }

    const stopChanelPolling = () => {
      if (chanelProgressPolling.value) {
        clearInterval(chanelProgressPolling.value)
        chanelProgressPolling.value = null
      }
    }

    const pollChanelProgress = () => {
      stopChanelPolling()
      chanelProgressPolling.value = setInterval(async () => {
        try {
          const resp = await apiService.getSheetsSyncProgress('chanel')
          if (resp.data.running) {
            chanelSyncProgress.value = resp.data
          } else {
            chanelSyncProgress.value = null
            stopChanelPolling()
            syncingChanel.value = false
            await loadChanelLastSync()
            if (resp.data.error) {
              toast.add({ severity: 'error', summary: 'Ошибка синхронизации', detail: resp.data.error, life: 5000 })
            } else if (resp.data.stage === 'completed') {
              toast.add({ severity: 'success', summary: 'Синхронизация цен завершена', life: 3000 })
            }
          }
        } catch (e) {
          console.error('Error polling chanel progress:', e)
        }
      }, 2000)
    }

    const startChanelSync = async () => {
      if (syncingChanel.value) return
      syncingChanel.value = true

      try {
        const statusResp = await apiService.checkChanelSyncRunning()
        if (statusResp.data.running) {
          toast.add({
            severity: 'warn',
            summary: 'Синхронизация уже выполняется',
            detail: 'Отображаем текущий прогресс',
            life: 3000
          })
          pollChanelProgress()
          return
        }

        await apiService.triggerChanelSync()
        pollChanelProgress()
      } catch (error) {
        if (error.response?.status === 409) {
          pollChanelProgress()
        } else {
          toast.add({
            severity: 'error',
            summary: 'Ошибка синхронизации',
            detail: error.response?.data?.detail || error.message,
            life: 5000
          })
          syncingChanel.value = false
        }
      }
    }

    // При открытии диалога Google Sheets — проверяем, не идёт ли синк (scheduler)
    watch(showSheetsSyncDialog, async (visible) => {
      if (visible) {
        try {
          const resp = await apiService.getSheetsSyncProgress('sheets')
          if (resp.data.running) {
            syncingSheets.value = true
            sheetsSyncProgress.value = resp.data
            pollSheetsProgress()
          }
        } catch (e) { /* ignore */ }
        try {
          const resp = await apiService.getSheetsSyncProgress('chanel')
          if (resp.data.running) {
            syncingChanel.value = true
            chanelSyncProgress.value = resp.data
            pollChanelProgress()
          }
        } catch (e) { /* ignore */ }
      } else {
        stopSheetsPolling()
        stopChanelPolling()
      }
    })

    onMounted(() => {
      loadFilterOptions()
      loadProducts()
      loadLastSync()
      loadChanelLastSync()
      loadCustomColumns()
    })

    onUnmounted(() => {
      stopSheetsPolling()
      stopChanelPolling()
    })

    return {
      products,
      loading,
      refreshing,
      totalRecords,
      selectedProduct,
      editDialogVisible,
      deleteDialogVisible,
      imageDialogVisible,
      showExportDialog,
      showBulkEditDialog,
      selectedImages,
      imageModalTitle,
      saving,
      deleting,
      filters,
      brandOptions,
      categoryOptions,
      colorOptions,
      conditionOptions,
      inStockOptions,
      siteStatusOptions,
      flagOptions,
      statusOptions,
      // Каталог: переключатель «Очки / Линзы»
      catalogView,
      catalogViewOptions,
      lensTypeOptions,
      lensesColumns,
      onCatalogViewChange,
      loadProducts,
      applyFilters,
      debouncedSearch,
      // Sync dialog
      showSyncDialog,
      syncOptions,
      hasSelectedOptions,
      startSync,
      onPage,
      onSort,
      onRowSelect,
      onCellEditComplete,
      editProduct,
      saveProduct,
      confirmDelete,
      deleteProduct,
      hasImages,
      getImageCount,
      openImagesModal,
      // UPC Converter
      showUpcConverterDialog,
      upcCodesInput,
      convertingUpc,
      convertUpcToTnved,
      // Shipment Export
      showShipmentExportDialog,
      // Google Sheets Sync
      showSheetsSyncDialog,
      syncingSheets,
      lastSync,
      downloadingReport,
      formatDate,
      loadLastSync,
      startSheetsSync,
      downloadSyncReport,
      sheetsSyncActiveTab,
      sheetsSyncProgress,
      // Chanel Perfumes Sync
      syncingChanel,
      chanelLastSync,
      startChanelSync,
      chanelSyncProgress,
      // Custom columns
      customColumns,
      getCustomFieldValue
    }
  }
}
</script>

<style scoped>
.data-editor {
  max-width: 1400px;
  margin: 0 auto;
}

.filters-section {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Sync dialog checkbox styles */
.field-checkbox {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s;
}

.field-checkbox:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.field-checkbox label {
  cursor: pointer;
  flex: 1;
}

.field-checkbox label strong {
  display: block;
  margin-bottom: 0.25rem;
  color: #495057;
}

.images-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.image-modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 1rem;
}

.image-modal-item {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 0.5rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-modal-item img {
  width: 100%;
  height: 160px;
  object-fit: contain;
  background: #f8f9fa;
  border-radius: 6px;
}

.font-monospace {
  font-family: 'Courier New', monospace;
}

/* Горизонтальный скролл для широкой таблицы */
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
}

:deep(.wide-products-table) {
  min-width: 1800px;
}

:deep(.wide-products-table .p-datatable-tbody > tr > td) {
  padding: 0.75rem 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

:deep(.wide-products-table .p-datatable-thead > tr > th) {
  padding: 0.75rem 0.5rem;
  white-space: nowrap;
}

/* Компактные стили для таблицы */
:deep(.p-datatable-sm .p-datatable-tbody > tr > td) {
  padding: 0.5rem 0.25rem;
  font-size: 0.875rem;
}

:deep(.p-datatable-sm .p-datatable-thead > tr > th) {
  padding: 0.5rem 0.25rem;
  font-size: 0.875rem;
}

:deep(.description-cell) {
  display: inline-block;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
  :deep(.p-card-title) .flex.align-items-center.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.75rem;
  }
}
</style>
